export const password = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;
